export class DateRangeModel {
  contactHistoryStartDate: Date;
  contactHistoryEndDate: Date;

  constructor(contactHistoryStartDate?: Date, contactHistoryEndDate?: Date) {
    this.contactHistoryStartDate = contactHistoryStartDate;
    this.contactHistoryEndDate = contactHistoryEndDate;
  }
}
